





































import Vue from 'vue'
export default Vue.extend({
  name: 'BookmarkCard',
  props: {
    showRemove: {
      type: Boolean,
      default: true
    },
    imageUrl: {
      type: String,
      default: 'https://via.placeholder.com/308x172'
    },
    category: String,
    title: String,
    description: String
  },
  methods: {
    removeButtonPressed (event: KeyboardEvent) {
      if ([10, 13].some(code => code === event.keyCode)) {
        this.$emit('removeBookmark')
      }
    },
    removeButtonClicked () {
      (this.$refs.bookmarkRemoveButton as any).blur()
      this.$emit('removeBookmark')
    }
  }
})
